// extracted by mini-css-extract-plugin
export default {"wrapper":"MatBang_wrapper__3KD1p","container":"MatBang_container__p9Nmj","content":"MatBang_content__j6oL0"};